// source: itrdrinstrumentstatus.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var fix_pb = require('./fix_pb.js');
goog.object.extend(proto, fix_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
var securitiesreferencedata_pb = require('./securitiesreferencedata_pb.js');
goog.object.extend(proto, securitiesreferencedata_pb);
var itrdrmsgs_common_pb = require('./itrdrmsgs_common_pb.js');
goog.object.extend(proto, itrdrmsgs_common_pb);
goog.exportSymbol('proto.it_grpc.ITrdrInstrumentStats', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrInstrumentStatusFlags', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrInstrumentStatusFlags.HaltReasonUnionCase', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrInstrumentStatusFlags.SecurityTradingStatusUnionCase', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrInstrumentStatusSummary', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrInstrumentStatusSummaryFields', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrSecurityDefinition', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrInstrumentStatusSummaryFields = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrInstrumentStatusSummaryFields, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrInstrumentStatusSummaryFields.displayName = 'proto.it_grpc.ITrdrInstrumentStatusSummaryFields';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrInstrumentStatusSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.ITrdrInstrumentStatusSummary.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.ITrdrInstrumentStatusSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrInstrumentStatusSummary.displayName = 'proto.it_grpc.ITrdrInstrumentStatusSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrInstrumentStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrInstrumentStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrInstrumentStats.displayName = 'proto.it_grpc.ITrdrInstrumentStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrInstrumentStatusFlags = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.it_grpc.ITrdrInstrumentStatusFlags.oneofGroups_);
};
goog.inherits(proto.it_grpc.ITrdrInstrumentStatusFlags, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrInstrumentStatusFlags.displayName = 'proto.it_grpc.ITrdrInstrumentStatusFlags';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrSecurityDefinition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.ITrdrSecurityDefinition.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.ITrdrSecurityDefinition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrSecurityDefinition.displayName = 'proto.it_grpc.ITrdrSecurityDefinition';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrInstrumentStatusSummaryFields.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrInstrumentStatusSummaryFields.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrInstrumentStatusSummaryFields} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentStatusSummaryFields.toObject = function(includeInstance, msg) {
  var f, obj = {
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    marketSegmentId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrInstrumentStatusSummaryFields}
 */
proto.it_grpc.ITrdrInstrumentStatusSummaryFields.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrInstrumentStatusSummaryFields;
  return proto.it_grpc.ITrdrInstrumentStatusSummaryFields.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrInstrumentStatusSummaryFields} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrInstrumentStatusSummaryFields}
 */
proto.it_grpc.ITrdrInstrumentStatusSummaryFields.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketSegmentId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrInstrumentStatusSummaryFields.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrInstrumentStatusSummaryFields.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrInstrumentStatusSummaryFields} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentStatusSummaryFields.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMarketSegmentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.it_grpc.ITrdrInstrumentStatusSummaryFields.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrInstrumentStatusSummaryFields} returns this
 */
proto.it_grpc.ITrdrInstrumentStatusSummaryFields.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string market_segment_id = 2;
 * @return {string}
 */
proto.it_grpc.ITrdrInstrumentStatusSummaryFields.prototype.getMarketSegmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrInstrumentStatusSummaryFields} returns this
 */
proto.it_grpc.ITrdrInstrumentStatusSummaryFields.prototype.setMarketSegmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string symbol = 3;
 * @return {string}
 */
proto.it_grpc.ITrdrInstrumentStatusSummaryFields.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrInstrumentStatusSummaryFields} returns this
 */
proto.it_grpc.ITrdrInstrumentStatusSummaryFields.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.ITrdrInstrumentStatusSummary.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrInstrumentStatusSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrInstrumentStatusSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrInstrumentStatusSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentStatusSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    instSummaryList: jspb.Message.toObjectList(msg.getInstSummaryList(),
    proto.it_grpc.ITrdrInstrumentStatusSummaryFields.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrInstrumentStatusSummary}
 */
proto.it_grpc.ITrdrInstrumentStatusSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrInstrumentStatusSummary;
  return proto.it_grpc.ITrdrInstrumentStatusSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrInstrumentStatusSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrInstrumentStatusSummary}
 */
proto.it_grpc.ITrdrInstrumentStatusSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.it_grpc.ITrdrInstrumentStatusSummaryFields;
      reader.readMessage(value,proto.it_grpc.ITrdrInstrumentStatusSummaryFields.deserializeBinaryFromReader);
      msg.addInstSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrInstrumentStatusSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrInstrumentStatusSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrInstrumentStatusSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentStatusSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstSummaryList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.it_grpc.ITrdrInstrumentStatusSummaryFields.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ITrdrInstrumentStatusSummaryFields inst_summary = 1;
 * @return {!Array<!proto.it_grpc.ITrdrInstrumentStatusSummaryFields>}
 */
proto.it_grpc.ITrdrInstrumentStatusSummary.prototype.getInstSummaryList = function() {
  return /** @type{!Array<!proto.it_grpc.ITrdrInstrumentStatusSummaryFields>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.ITrdrInstrumentStatusSummaryFields, 1));
};


/**
 * @param {!Array<!proto.it_grpc.ITrdrInstrumentStatusSummaryFields>} value
 * @return {!proto.it_grpc.ITrdrInstrumentStatusSummary} returns this
*/
proto.it_grpc.ITrdrInstrumentStatusSummary.prototype.setInstSummaryList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.it_grpc.ITrdrInstrumentStatusSummaryFields=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrInstrumentStatusSummaryFields}
 */
proto.it_grpc.ITrdrInstrumentStatusSummary.prototype.addInstSummary = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.it_grpc.ITrdrInstrumentStatusSummaryFields, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrInstrumentStatusSummary} returns this
 */
proto.it_grpc.ITrdrInstrumentStatusSummary.prototype.clearInstSummaryList = function() {
  return this.setInstSummaryList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrInstrumentStats.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrInstrumentStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrInstrumentStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentStats.toObject = function(includeInstance, msg) {
  var f, obj = {
    buyVolume: (f = msg.getBuyVolume()) && fix_pb.Decimal64.toObject(includeInstance, f),
    sellVolume: (f = msg.getSellVolume()) && fix_pb.Decimal64.toObject(includeInstance, f),
    highPx: (f = msg.getHighPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    lowPx: (f = msg.getLowPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    firstPx: (f = msg.getFirstPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    lastPx: (f = msg.getLastPx()) && fix_pb.Decimal64.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrInstrumentStats}
 */
proto.it_grpc.ITrdrInstrumentStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrInstrumentStats;
  return proto.it_grpc.ITrdrInstrumentStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrInstrumentStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrInstrumentStats}
 */
proto.it_grpc.ITrdrInstrumentStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setBuyVolume(value);
      break;
    case 2:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setSellVolume(value);
      break;
    case 3:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setHighPx(value);
      break;
    case 4:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLowPx(value);
      break;
    case 5:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setFirstPx(value);
      break;
    case 6:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLastPx(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrInstrumentStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrInstrumentStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrInstrumentStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBuyVolume();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getSellVolume();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getHighPx();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLowPx();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getFirstPx();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLastPx();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
};


/**
 * optional fix.Decimal64 buy_volume = 1;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrInstrumentStats.prototype.getBuyVolume = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 1));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrumentStats} returns this
*/
proto.it_grpc.ITrdrInstrumentStats.prototype.setBuyVolume = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentStats} returns this
 */
proto.it_grpc.ITrdrInstrumentStats.prototype.clearBuyVolume = function() {
  return this.setBuyVolume(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentStats.prototype.hasBuyVolume = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional fix.Decimal64 sell_volume = 2;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrInstrumentStats.prototype.getSellVolume = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 2));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrumentStats} returns this
*/
proto.it_grpc.ITrdrInstrumentStats.prototype.setSellVolume = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentStats} returns this
 */
proto.it_grpc.ITrdrInstrumentStats.prototype.clearSellVolume = function() {
  return this.setSellVolume(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentStats.prototype.hasSellVolume = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional fix.Decimal64 high_px = 3;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrInstrumentStats.prototype.getHighPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 3));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrumentStats} returns this
*/
proto.it_grpc.ITrdrInstrumentStats.prototype.setHighPx = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentStats} returns this
 */
proto.it_grpc.ITrdrInstrumentStats.prototype.clearHighPx = function() {
  return this.setHighPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentStats.prototype.hasHighPx = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional fix.Decimal64 low_px = 4;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrInstrumentStats.prototype.getLowPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 4));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrumentStats} returns this
*/
proto.it_grpc.ITrdrInstrumentStats.prototype.setLowPx = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentStats} returns this
 */
proto.it_grpc.ITrdrInstrumentStats.prototype.clearLowPx = function() {
  return this.setLowPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentStats.prototype.hasLowPx = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional fix.Decimal64 first_px = 5;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrInstrumentStats.prototype.getFirstPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 5));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrumentStats} returns this
*/
proto.it_grpc.ITrdrInstrumentStats.prototype.setFirstPx = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentStats} returns this
 */
proto.it_grpc.ITrdrInstrumentStats.prototype.clearFirstPx = function() {
  return this.setFirstPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentStats.prototype.hasFirstPx = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional fix.Decimal64 last_px = 6;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrInstrumentStats.prototype.getLastPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 6));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrumentStats} returns this
*/
proto.it_grpc.ITrdrInstrumentStats.prototype.setLastPx = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentStats} returns this
 */
proto.it_grpc.ITrdrInstrumentStats.prototype.clearLastPx = function() {
  return this.setLastPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentStats.prototype.hasLastPx = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.oneofGroups_ = [[2,3],[4,5]];

/**
 * @enum {number}
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.HaltReasonUnionCase = {
  HALT_REASON_UNION_NOT_SET: 0,
  HALT_REASON: 2,
  HALT_REASON_RESERVED100PLUS: 3
};

/**
 * @return {proto.it_grpc.ITrdrInstrumentStatusFlags.HaltReasonUnionCase}
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.prototype.getHaltReasonUnionCase = function() {
  return /** @type {proto.it_grpc.ITrdrInstrumentStatusFlags.HaltReasonUnionCase} */(jspb.Message.computeOneofCase(this, proto.it_grpc.ITrdrInstrumentStatusFlags.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.SecurityTradingStatusUnionCase = {
  SECURITY_TRADING_STATUS_UNION_NOT_SET: 0,
  SECURITY_TRADING_STATUS: 4,
  SECURITY_TRADING_STATUS_RESERVED100PLUS: 5
};

/**
 * @return {proto.it_grpc.ITrdrInstrumentStatusFlags.SecurityTradingStatusUnionCase}
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.prototype.getSecurityTradingStatusUnionCase = function() {
  return /** @type {proto.it_grpc.ITrdrInstrumentStatusFlags.SecurityTradingStatusUnionCase} */(jspb.Message.computeOneofCase(this, proto.it_grpc.ITrdrInstrumentStatusFlags.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrInstrumentStatusFlags.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrInstrumentStatusFlags} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.toObject = function(includeInstance, msg) {
  var f, obj = {
    dueToRelated: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    haltReason: jspb.Message.getFieldWithDefault(msg, 2, 0),
    haltReasonReserved100plus: jspb.Message.getFieldWithDefault(msg, 3, 0),
    securityTradingStatus: jspb.Message.getFieldWithDefault(msg, 4, 0),
    securityTradingStatusReserved100plus: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrInstrumentStatusFlags}
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrInstrumentStatusFlags;
  return proto.it_grpc.ITrdrInstrumentStatusFlags.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrInstrumentStatusFlags} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrInstrumentStatusFlags}
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDueToRelated(value);
      break;
    case 2:
      var value = /** @type {!proto.SecuritiesReferenceData.HaltReasonEnum} */ (reader.readEnum());
      msg.setHaltReason(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setHaltReasonReserved100plus(value);
      break;
    case 4:
      var value = /** @type {!proto.SecuritiesReferenceData.SecurityTradingStatusEnum} */ (reader.readEnum());
      msg.setSecurityTradingStatus(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSecurityTradingStatusReserved100plus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrInstrumentStatusFlags.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrInstrumentStatusFlags} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDueToRelated();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.HaltReasonEnum} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeFixed32(
      3,
      f
    );
  }
  f = /** @type {!proto.SecuritiesReferenceData.SecurityTradingStatusEnum} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeFixed32(
      5,
      f
    );
  }
};


/**
 * optional bool due_to_related = 1;
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.prototype.getDueToRelated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.ITrdrInstrumentStatusFlags} returns this
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.prototype.setDueToRelated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional SecuritiesReferenceData.HaltReasonEnum halt_reason = 2;
 * @return {!proto.SecuritiesReferenceData.HaltReasonEnum}
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.prototype.getHaltReason = function() {
  return /** @type {!proto.SecuritiesReferenceData.HaltReasonEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.HaltReasonEnum} value
 * @return {!proto.it_grpc.ITrdrInstrumentStatusFlags} returns this
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.prototype.setHaltReason = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.it_grpc.ITrdrInstrumentStatusFlags.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentStatusFlags} returns this
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.prototype.clearHaltReason = function() {
  return jspb.Message.setOneofField(this, 2, proto.it_grpc.ITrdrInstrumentStatusFlags.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.prototype.hasHaltReason = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional fixed32 halt_reason_reserved100plus = 3;
 * @return {number}
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.prototype.getHaltReasonReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrInstrumentStatusFlags} returns this
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.prototype.setHaltReasonReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.it_grpc.ITrdrInstrumentStatusFlags.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentStatusFlags} returns this
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.prototype.clearHaltReasonReserved100plus = function() {
  return jspb.Message.setOneofField(this, 3, proto.it_grpc.ITrdrInstrumentStatusFlags.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.prototype.hasHaltReasonReserved100plus = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional SecuritiesReferenceData.SecurityTradingStatusEnum security_trading_status = 4;
 * @return {!proto.SecuritiesReferenceData.SecurityTradingStatusEnum}
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.prototype.getSecurityTradingStatus = function() {
  return /** @type {!proto.SecuritiesReferenceData.SecurityTradingStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.SecuritiesReferenceData.SecurityTradingStatusEnum} value
 * @return {!proto.it_grpc.ITrdrInstrumentStatusFlags} returns this
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.prototype.setSecurityTradingStatus = function(value) {
  return jspb.Message.setOneofField(this, 4, proto.it_grpc.ITrdrInstrumentStatusFlags.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentStatusFlags} returns this
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.prototype.clearSecurityTradingStatus = function() {
  return jspb.Message.setOneofField(this, 4, proto.it_grpc.ITrdrInstrumentStatusFlags.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.prototype.hasSecurityTradingStatus = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional fixed32 security_trading_status_reserved100plus = 5;
 * @return {number}
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.prototype.getSecurityTradingStatusReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrInstrumentStatusFlags} returns this
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.prototype.setSecurityTradingStatusReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 5, proto.it_grpc.ITrdrInstrumentStatusFlags.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentStatusFlags} returns this
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.prototype.clearSecurityTradingStatusReserved100plus = function() {
  return jspb.Message.setOneofField(this, 5, proto.it_grpc.ITrdrInstrumentStatusFlags.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentStatusFlags.prototype.hasSecurityTradingStatusReserved100plus = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.ITrdrSecurityDefinition.repeatedFields_ = [12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrSecurityDefinition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrSecurityDefinition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrSecurityDefinition.toObject = function(includeInstance, msg) {
  var f, obj = {
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    marketSegmentId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    securityId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    instType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    instSubType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    marketDepth: jspb.Message.getFieldWithDefault(msg, 6, 0),
    mdBookType: jspb.Message.getFieldWithDefault(msg, 7, 0),
    currency: jspb.Message.getFieldWithDefault(msg, 8, ""),
    statusFlags: (f = msg.getStatusFlags()) && proto.it_grpc.ITrdrInstrumentStatusFlags.toObject(includeInstance, f),
    instStats: (f = msg.getInstStats()) && proto.it_grpc.ITrdrInstrumentStats.toObject(includeInstance, f),
    baeTradingRules: (f = msg.getBaeTradingRules()) && common_pb.BaseTradingRules.toObject(includeInstance, f),
    stipulationsList: jspb.Message.toObjectList(msg.getStipulationsList(),
    common_pb.Stipulations.toObject, includeInstance),
    clearingBusinessDate: jspb.Message.getFieldWithDefault(msg, 13, 0),
    yieldData: (f = msg.getYieldData()) && common_pb.YieldData.toObject(includeInstance, f),
    text: jspb.Message.getFieldWithDefault(msg, 26, ""),
    transactTime: (f = msg.getTransactTime()) && fix_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrSecurityDefinition}
 */
proto.it_grpc.ITrdrSecurityDefinition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrSecurityDefinition;
  return proto.it_grpc.ITrdrSecurityDefinition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrSecurityDefinition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrSecurityDefinition}
 */
proto.it_grpc.ITrdrSecurityDefinition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketSegmentId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityId(value);
      break;
    case 4:
      var value = /** @type {!proto.it_grpc.ItrdrInstrumentTypeEnum} */ (reader.readEnum());
      msg.setInstType(value);
      break;
    case 5:
      var value = /** @type {!proto.it_grpc.ItrdrInstrumentSubTypeEnum} */ (reader.readEnum());
      msg.setInstSubType(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setMarketDepth(value);
      break;
    case 7:
      var value = /** @type {!proto.Common.MDBookTypeEnum} */ (reader.readEnum());
      msg.setMdBookType(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 9:
      var value = new proto.it_grpc.ITrdrInstrumentStatusFlags;
      reader.readMessage(value,proto.it_grpc.ITrdrInstrumentStatusFlags.deserializeBinaryFromReader);
      msg.setStatusFlags(value);
      break;
    case 10:
      var value = new proto.it_grpc.ITrdrInstrumentStats;
      reader.readMessage(value,proto.it_grpc.ITrdrInstrumentStats.deserializeBinaryFromReader);
      msg.setInstStats(value);
      break;
    case 11:
      var value = new common_pb.BaseTradingRules;
      reader.readMessage(value,common_pb.BaseTradingRules.deserializeBinaryFromReader);
      msg.setBaeTradingRules(value);
      break;
    case 12:
      var value = new common_pb.Stipulations;
      reader.readMessage(value,common_pb.Stipulations.deserializeBinaryFromReader);
      msg.addStipulations(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setClearingBusinessDate(value);
      break;
    case 14:
      var value = new common_pb.YieldData;
      reader.readMessage(value,common_pb.YieldData.deserializeBinaryFromReader);
      msg.setYieldData(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 15:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTransactTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrSecurityDefinition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrSecurityDefinition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrSecurityDefinition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMarketSegmentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSecurityId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getInstType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getInstSubType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getMarketDepth();
  if (f !== 0) {
    writer.writeSfixed64(
      6,
      f
    );
  }
  f = message.getMdBookType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getStatusFlags();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.it_grpc.ITrdrInstrumentStatusFlags.serializeBinaryToWriter
    );
  }
  f = message.getInstStats();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.it_grpc.ITrdrInstrumentStats.serializeBinaryToWriter
    );
  }
  f = message.getBaeTradingRules();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      common_pb.BaseTradingRules.serializeBinaryToWriter
    );
  }
  f = message.getStipulationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      common_pb.Stipulations.serializeBinaryToWriter
    );
  }
  f = message.getClearingBusinessDate();
  if (f !== 0) {
    writer.writeSfixed32(
      13,
      f
    );
  }
  f = message.getYieldData();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      common_pb.YieldData.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getTransactTime();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrSecurityDefinition} returns this
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string market_segment_id = 2;
 * @return {string}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.getMarketSegmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrSecurityDefinition} returns this
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.setMarketSegmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string security_id = 3;
 * @return {string}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.getSecurityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrSecurityDefinition} returns this
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.setSecurityId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional ItrdrInstrumentTypeEnum inst_type = 4;
 * @return {!proto.it_grpc.ItrdrInstrumentTypeEnum}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.getInstType = function() {
  return /** @type {!proto.it_grpc.ItrdrInstrumentTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.it_grpc.ItrdrInstrumentTypeEnum} value
 * @return {!proto.it_grpc.ITrdrSecurityDefinition} returns this
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.setInstType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional ItrdrInstrumentSubTypeEnum inst_sub_type = 5;
 * @return {!proto.it_grpc.ItrdrInstrumentSubTypeEnum}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.getInstSubType = function() {
  return /** @type {!proto.it_grpc.ItrdrInstrumentSubTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.it_grpc.ItrdrInstrumentSubTypeEnum} value
 * @return {!proto.it_grpc.ITrdrSecurityDefinition} returns this
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.setInstSubType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional sfixed64 market_depth = 6;
 * @return {number}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.getMarketDepth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrSecurityDefinition} returns this
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.setMarketDepth = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional Common.MDBookTypeEnum md_book_type = 7;
 * @return {!proto.Common.MDBookTypeEnum}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.getMdBookType = function() {
  return /** @type {!proto.Common.MDBookTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.Common.MDBookTypeEnum} value
 * @return {!proto.it_grpc.ITrdrSecurityDefinition} returns this
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.setMdBookType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string currency = 8;
 * @return {string}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrSecurityDefinition} returns this
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional ITrdrInstrumentStatusFlags status_flags = 9;
 * @return {?proto.it_grpc.ITrdrInstrumentStatusFlags}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.getStatusFlags = function() {
  return /** @type{?proto.it_grpc.ITrdrInstrumentStatusFlags} */ (
    jspb.Message.getWrapperField(this, proto.it_grpc.ITrdrInstrumentStatusFlags, 9));
};


/**
 * @param {?proto.it_grpc.ITrdrInstrumentStatusFlags|undefined} value
 * @return {!proto.it_grpc.ITrdrSecurityDefinition} returns this
*/
proto.it_grpc.ITrdrSecurityDefinition.prototype.setStatusFlags = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrSecurityDefinition} returns this
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.clearStatusFlags = function() {
  return this.setStatusFlags(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.hasStatusFlags = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional ITrdrInstrumentStats inst_stats = 10;
 * @return {?proto.it_grpc.ITrdrInstrumentStats}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.getInstStats = function() {
  return /** @type{?proto.it_grpc.ITrdrInstrumentStats} */ (
    jspb.Message.getWrapperField(this, proto.it_grpc.ITrdrInstrumentStats, 10));
};


/**
 * @param {?proto.it_grpc.ITrdrInstrumentStats|undefined} value
 * @return {!proto.it_grpc.ITrdrSecurityDefinition} returns this
*/
proto.it_grpc.ITrdrSecurityDefinition.prototype.setInstStats = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrSecurityDefinition} returns this
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.clearInstStats = function() {
  return this.setInstStats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.hasInstStats = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional Common.BaseTradingRules bae_trading_rules = 11;
 * @return {?proto.Common.BaseTradingRules}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.getBaeTradingRules = function() {
  return /** @type{?proto.Common.BaseTradingRules} */ (
    jspb.Message.getWrapperField(this, common_pb.BaseTradingRules, 11));
};


/**
 * @param {?proto.Common.BaseTradingRules|undefined} value
 * @return {!proto.it_grpc.ITrdrSecurityDefinition} returns this
*/
proto.it_grpc.ITrdrSecurityDefinition.prototype.setBaeTradingRules = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrSecurityDefinition} returns this
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.clearBaeTradingRules = function() {
  return this.setBaeTradingRules(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.hasBaeTradingRules = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * repeated Common.Stipulations stipulations = 12;
 * @return {!Array<!proto.Common.Stipulations>}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.getStipulationsList = function() {
  return /** @type{!Array<!proto.Common.Stipulations>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Stipulations, 12));
};


/**
 * @param {!Array<!proto.Common.Stipulations>} value
 * @return {!proto.it_grpc.ITrdrSecurityDefinition} returns this
*/
proto.it_grpc.ITrdrSecurityDefinition.prototype.setStipulationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.Common.Stipulations=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.Stipulations}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.addStipulations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.Common.Stipulations, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrSecurityDefinition} returns this
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.clearStipulationsList = function() {
  return this.setStipulationsList([]);
};


/**
 * optional sfixed32 clearing_business_date = 13;
 * @return {number}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.getClearingBusinessDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrSecurityDefinition} returns this
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.setClearingBusinessDate = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional Common.YieldData yield_data = 14;
 * @return {?proto.Common.YieldData}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.getYieldData = function() {
  return /** @type{?proto.Common.YieldData} */ (
    jspb.Message.getWrapperField(this, common_pb.YieldData, 14));
};


/**
 * @param {?proto.Common.YieldData|undefined} value
 * @return {!proto.it_grpc.ITrdrSecurityDefinition} returns this
*/
proto.it_grpc.ITrdrSecurityDefinition.prototype.setYieldData = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrSecurityDefinition} returns this
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.clearYieldData = function() {
  return this.setYieldData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.hasYieldData = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional string text = 26;
 * @return {string}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrSecurityDefinition} returns this
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional fix.Timestamp transact_time = 15;
 * @return {?proto.fix.Timestamp}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.getTransactTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 15));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.it_grpc.ITrdrSecurityDefinition} returns this
*/
proto.it_grpc.ITrdrSecurityDefinition.prototype.setTransactTime = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrSecurityDefinition} returns this
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.clearTransactTime = function() {
  return this.setTransactTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrSecurityDefinition.prototype.hasTransactTime = function() {
  return jspb.Message.getField(this, 15) != null;
};


goog.object.extend(exports, proto.it_grpc);
